import {html, PolymerElement} from '@polymer/polymer/polymer-element.js';
import '@cbar/cbar-shared-styles/cbar-shared-styles.js';
import '@cbar/localizemixin/LocalizeMixin.js';
import '@polymer/paper-button/paper-button.js';
import '@polymer/paper-spinner/paper-spinner.js';
import '@polymer/paper-dialog/paper-dialog.js';
import '@polymer/iron-image/iron-image.js';
/**
 * `cbar-app-logout`
 * 
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarAppLogout extends Cbar.LocalizeMixin(PolymerElement) {
  static get template() {
    return html`
      <style include="cbar-shared-styles">
        :host {
          display: block;
        }
        paper-dialog{
        display: flex;
        flex-direction: column;
        align-items: center;
        }
        .buttons {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        }
        paper-button[disabled]{
        color: grey;
        }
        iron-image{
        padding: 0;
        margin-bottom: 24px;
        height: 200px;
        width: 200px;
        border: 5px solid #eeeeee;
        border-radius: 50%;
        }
      </style>
      <paper-dialog id="dialog" with-backdrop opened="{{opened}}" no-cancel-on-outside-click>
        <iron-image src="[[image]]" sizing="cover"></iron-image>
        <h6>Confirm Log Out</h2>
        
        <div>
        Use Log Out to leave this application, or Forget Device if other people use this device.
        </div>
        
        <div class="buttons">
            <paper-spinner active="[[processing]]"></paper-spinner>
            <paper-button dialog-dismiss disabled$="[[processing]]">[[localize('Cancel')]]</paper-button>
            <paper-button on-tap="fireAuthLogout" disabled$="[[processing]]" id="auth-logout">Forget Device</paper-button>
            <paper-button on-tap="fireAppLogout" disabled$="[[processing]]" id="app-logout">Log Out</paper-button>
        </div>
      </paper-dialog>
    `;
  }
  static get properties() {
    return {
      image : {
        type: String,
        value: ""
      },
      opened: {
        type: Boolean,
        value: false
      },
      processing: {
        type: Boolean,
        value: false
      },
      authClientName: {
        type: String,
        value: "Authentickated"
      }
    };
  }

  toggle(){
    this.opened = !this.opened;
  }

  fireAppLogout(){
    this.processing = true;
    this.dispatchEvent(new CustomEvent('app-logout', {
      bubbles: true,
      composed: true,
      detail : {
        auth: false
      }
    }));
  }

  fireAuthLogout(){
    this.processing = true;
    this.dispatchEvent(new CustomEvent('auth-logout', {
      bubbles: true,
      composed: true,
      detail: {
        auth: true
      }
    }));
  }
}

window.customElements.define('cbar-app-logout', CbarAppLogout);
